import {get} from "lodash"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import BaseService from "./Base"

export type StudentActivityCommentAuthor = {
    profileId: number
    userId: number
    fullName: string
    photo: {url?: string} | null
}

export type StudentActivityComment = {
    studentActivityCommentId: number
    studentActivityId: number
    comment: string
    createdProfileId: number
    updatedProfileId: number | null
    createdAt: string
    updatedAt: string
    createdByProfile: StudentActivityCommentAuthor | null
    updatedByProfile: StudentActivityCommentAuthor | null
}

export default class StudentActivityCommentsService extends BaseService {
    async list(studentActivityId: number): Promise<{data: StudentActivityComment[]; total: number}> {
        const response = await this.post("/v1/student-activity-comments/list", {
            filter: {studentActivityId},
            range: {page: 1, pageSize: UNLIMITED_PAGE_SIZE}
        })
        return get(response, "data", {data: [], total: 0})
    }

    async create(studentActivityId: number, comment: string): Promise<StudentActivityComment> {
        const response = await this.post("/v1/student-activity-comments/create", {
            studentActivityId,
            comment
        })
        return get(response, "data.data", {})
    }

    async edit(studentActivityCommentId: number, comment: string): Promise<StudentActivityComment> {
        const response = await this.post("/v1/student-activity-comments/edit", {
            studentActivityCommentId,
            comment
        })
        return get(response, "data.data", {})
    }

    async deleteComment(studentActivityCommentId: number): Promise<void> {
        await this.post("/v1/student-activity-comments/delete", {studentActivityCommentId})
    }
}
